<div class="sent-emails">
    <cerrix-title size="large" editable="false" value="Sent email messages"></cerrix-title>

    <div class="top-bar">
        <cerrix-input
            placeholder="Search..."
            class="search-input"
            suffixIcon="search"
            [(ngModel)]="searchValue"
            (ngModelChange)="onSearch(false)"
            (keydown.enter)="onSearch(true)"
        ></cerrix-input>

        <page-number-selector
            [pageSize]="pageSize"
            [pageSizeOptions]="[10, 25, 50, 100]"
            (pageNumberChanged)="onPageNumberChanged($event)"
        ></page-number-selector>
    </div>

    <div class="table-container">
        <div class="table-content">
            <table
                mat-table
                [dataSource]="emails"
                matSort
                fixedLayout
                [matSortActive]="sortActive"
                [matSortDirection]="sortDirection"
                (matSortChange)="onSortChange($event)"
            >
                <ng-container matColumnDef="DateSent">
                    <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header>
                        Date sent
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.dateSent | dateTimeDisplay: true : true }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="Subject">
                    <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header>Subject</th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        [matTooltip]="element.subject"
                        [matTooltipShowDelay]="tooltipDelay"
                    >
                        {{ element.subject }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="To">
                    <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header>
                        Recipient
                    </th>
                    <td
                        mat-cell
                        *matCellDef="let element"
                        [matTooltip]="element.to"
                        [matTooltipShowDelay]="tooltipDelay"
                    >
                        {{ element.to }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="EmailStatus">
                    <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header>
                        Delivered
                    </th>
                    <td mat-cell *matCellDef="let element">
                        @if (element.emailStatus === incidentEmailStatus.Sent) {
                            <mat-icon
                                class="email-status-icon sent"
                                fontSet="material-icons-outlined"
                                matTooltip="Sent"
                                >check_circle</mat-icon
                            >
                        } @else if (element.emailStatus === incidentEmailStatus.Failed) {
                            <mat-icon
                                class="email-status-icon error"
                                fontSet="material-icons-outlined"
                                matTooltip="Error"
                                >warning</mat-icon
                            >
                        } @else {
                            <mat-icon
                                class="email-status-icon"
                                fontSet="material-icons-outlined"
                                matTooltip="Pending"
                                >pending</mat-icon
                            >
                        }
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    (click)="openEmail(row)"
                ></tr>

                <tr *matNoDataRow>
                    <ng-container>
                        <td class="no-data-cell" [attr.colspan]="displayedColumns?.length">
                            No data matching the filter
                        </td>
                    </ng-container>
                </tr>
            </table>
        </div>

        <cerrix-paginator
            [length]="totalEmails"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            itemsPerPageLabel="showing sent email #from# - #to# of #total# sent emails"
            (pageIndexChanged)="onPageIndexChanged($event)"
        ></cerrix-paginator>
    </div>
</div>
